import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyCareerYagiofferFormatData,
  provideCareerYagiofferFormatData,
  useCareerYagiofferHistories
} from '@/composables/format-edit/useCareerYagiofferHistories'
import CareerYagiofferEduHistoryCard from './CareerYagiofferEduHistoryCard.vue'
import CareerYagiofferJobHistoryCard from './CareerYagiofferJobHistoryCard.vue'
import DownloadItem from '@/components/formats/CommonParts/YagiofferDownloadItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CareerYagiofferEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  basicData: Record<string, unknown>
  formatId?: string
  previewFormat?: { errorMessages?: Record<string, string> } | null
  currentCardId?: string
  exampleSentences?: Record<string, unknown>
};



const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'rirekisho',
  saveOtherName: 'shokumukeirekisho',
  createEmpty: createEmptyCareerYagiofferFormatData
})
provideCareerYagiofferFormatData(formatData)

const {
  activeHistoryItem,
  educationalResetDialogVisible,
  jobResetDialogVisible,
  setEducationalBackgrounds,
  setJobHistories,
  resetEducationalBackgrounds,
  resetJobHistories,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  activateHistoryItem
} = useCareerYagiofferHistories(formatData)

const descriptionMaxLength = 80
const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)
const downloadActiveCollapses = ref(['postcard'])

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

return { __sfc: true,props, formLib, formatData, activeHistoryItem, educationalResetDialogVisible, jobResetDialogVisible, setEducationalBackgrounds, setJobHistories, resetEducationalBackgrounds, resetJobHistories, addEducationalHistory, deleteEducationalHistory, moveEducationalHistory, addJobHistory, deleteJobHistory, moveJobHistory, activateHistoryItem, descriptionMaxLength, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, downloadActiveCollapses, previewErrors, dataChanged, CareerYagiofferEduHistoryCard, CareerYagiofferJobHistoryCard, DownloadItem }
}

})